import React from 'react';
import { styled } from 'styled-components';
import { useTranslation } from 'react-i18next';
import coworkerImage from '../assets/coworkers.png';

const ImageContainer = styled.div`
  background-color: rgba(140, 221, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 2rem;
  border-radius: 8px;
`;

const StyledImage = styled.img`
  max-width: 100%;
  height: auto;
`;

const CoworkerImage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <ImageContainer>
      <StyledImage
        src={coworkerImage}
        alt={t('pages.confirm.confirmImageAltText')}
      />
    </ImageContainer>
  );
};

export default CoworkerImage;
